export const filterDefault = () => {
    return {
        limit: 10,
        page: 1,
        search: "",
        state: null,
    }
}

export default {
    list :{
        data: [],
        total: 0
    },
    listActives:[],
    banner: {
        id: null,
        title: null,
        is_active: true,
        image: null,
        state: null,
        new_image: null,
        date_init: null,
        is_date_end: false,
        date_end: null,
        order: null,
    },

    defaultBanner: {
        id: null,
        title: null,
        is_active: null,
        image: null,
        state: null,
        new_image: null,
    },
    showModalForm: false,
    filter: filterDefault(),
    totalActives: 0,
};
